"use client";

import { X } from "lucide-react";
import { Drawer } from "@/components/ui";
import {
  TopSellersFiltersPanel,
  type FilterExcludeSection,
} from "@/features/topsellers/components/TopSellersFilters";
import type { TopSellersFilters, TopSellersFilterState } from "@/features/topsellers/types";

interface FiltersDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  titleId: string;
  filters: TopSellersFilters;
  value: TopSellersFilterState;
  onChange: (next: TopSellersFilterState) => void;
  onReset: () => void;
  onApply: () => void;
  excludeSections?: FilterExcludeSection[];
}

export function FiltersDrawer({
  isOpen,
  onClose,
  titleId,
  filters,
  value,
  onChange,
  onReset,
  onApply,
  excludeSections,
}: FiltersDrawerProps) {
  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      position="right"
      width="92vw"
      maxWidth="400px"
      titleId={titleId}
    >
      <div className="px-3 py-2 border-b border-[#2a475e]/50 flex items-center justify-between gap-3">
        <div>
          <div id={titleId} className="text-sm font-semibold text-white">
            Filters
          </div>
          <div className="text-[11px] text-[#8f98a0]">
            Applied after clicking &quot;Apply&quot;
          </div>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="h-8 w-8 inline-flex items-center justify-center rounded-lg border border-[#2a475e]/50 bg-[#1f2e3f]/30 text-[#c7d5e0] hover:bg-[#1f2e3f] hover:border-[#3a556e] transition-colors"
          aria-label="Close filters"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="p-3">
        <TopSellersFiltersPanel
          filters={filters}
          value={value}
          onChange={onChange}
          excludeSections={excludeSections}
        />
      </div>

      <div className="border-t border-[#2a475e]/50 p-3 bg-[#16202d] sticky bottom-0 z-[70] relative">
        <div className="flex items-center justify-between gap-2">
          <button
            type="button"
            onClick={onReset}
            className="h-9 px-3 rounded-lg border border-[#2a475e]/50 bg-transparent text-[#8f98a0] hover:text-white hover:bg-[#1f2e3f]/50 transition-colors text-sm font-medium"
          >
            Reset
          </button>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              className="h-9 px-3 rounded-lg border border-[#2a475e]/50 bg-transparent text-[#c7d5e0] hover:bg-[#1f2e3f]/50 transition-colors text-sm font-medium"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onApply();
              }}
              className="h-9 px-4 rounded-lg bg-[#66c0f4] text-[#0e1419] font-semibold text-sm hover:brightness-110 transition cursor-pointer"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
